export default {
	styleOverrides: theme => `
     @font-face {
      font-family: 'GreycliffCF';
      font-style: normal;
      font-display: swap;
      font-weight: 400;
      src: local('GreycliffCF-Regular'),
           url('/fonts/GreycliffCF-Regular.otf') format('opentype');
    }
    @font-face {
      font-family: 'GreycliffCF';
      font-style: normal;
      font-display: swap;
      font-weight: 500;
      src: local('GreycliffCF-Medium'),
           url('/fonts/GreycliffCF-Medium.otf') format('opentype');
    }
     @font-face {
      font-family: 'GreycliffCF';
      font-style: normal;
      font-display: swap;
      font-weight: 700;
      src: local('GreycliffCF-Bold'),
           url('/fonts/GreycliffCF-Bold.otf') format('opentype');
    }
     @font-face {
      font-family: 'GreycliffCF';
      font-style: normal;
      font-display: swap;
      font-weight: 900;
      src: local('GreycliffCF-Heavy'),
           url('/fonts/GreycliffCF-Heavy.otf') format('opentype');
    }
    `,
}
